import { call, put, takeEvery, takeLatest } from 'redux-saga/effects';
import { apiWrapper } from "../../../api/apiWrapper";
import { IBaseResponeModel } from '../../../models/response/base-response';
import { dm_doi_tuong_tuyen_sinh } from '../../../models/response/category/dm_doi_tuong_tuyen_sinh';
import { eDoiTuongTuyenSinhActionTypeIds, IDoiTuongTuyenSinhActionTypes } from '../../action-types/crm-category/IDmDoiTuongTuyenSinhActionTypes';
import { actions } from '../../actions/actionsWrapper';

export function* doiTuongTuyenSinhSaga(): any {
    yield takeLatest(eDoiTuongTuyenSinhActionTypeIds.LOAD_START, loadWorker)
    yield takeEvery(eDoiTuongTuyenSinhActionTypeIds.SAVE_START, saveWorker)
    yield takeEvery(eDoiTuongTuyenSinhActionTypeIds.DELETE_START, deleteWorker)
}

function* loadWorker(action: IDoiTuongTuyenSinhActionTypes): any {
    const dm_coso_id: number = action.payload as number;
    const res: IBaseResponeModel = yield call(apiWrapper.crmCategoryWrapper.doiTuongTuyenSinh.select_by_coso, dm_coso_id)
    if (res.is_success) {
        yield put(actions.crmCategoryWrapper.doiTuongTuyenSinh.LOAD_SUCCESS(res.data))
    } else {
        yield put(actions.crmCategoryWrapper.doiTuongTuyenSinh.LOAD_ERROR(res.message ?? "Error"))
    }
}

function* saveWorker(action: IDoiTuongTuyenSinhActionTypes): any {
    const payload: dm_doi_tuong_tuyen_sinh = action.payload as dm_doi_tuong_tuyen_sinh;
    let res: IBaseResponeModel;
    if (payload.id > 0) {
        res = yield call(apiWrapper.crmCategoryWrapper.doiTuongTuyenSinh.update, payload)
    } else {
        res = yield call(apiWrapper.crmCategoryWrapper.doiTuongTuyenSinh.insert, payload)
    }
    if (res.is_success) {
        yield put(actions.crmCategoryWrapper.doiTuongTuyenSinh.SAVE_SUCESS(res.data))
    } else {
        yield put(actions.crmCategoryWrapper.doiTuongTuyenSinh.SAVE_ERROR(res.message ?? "Error"))
    }
}

function* deleteWorker(action: IDoiTuongTuyenSinhActionTypes): any {
    const payload: number = action.payload as number;
    const res: IBaseResponeModel = yield call(apiWrapper.crmCategoryWrapper.doiTuongTuyenSinh.delete, payload)
    if (res.is_success) {
        yield put(actions.crmCategoryWrapper.doiTuongTuyenSinh.DELETE_SUCESS(undefined))
    } else {
        yield put(actions.crmCategoryWrapper.doiTuongTuyenSinh.DELETE_ERROR(res.message ?? "Error"))
    }
}
